import React from "react";
import { Container, Divider, Grid, Icon, List } from "semantic-ui-react";
import Helmet from "react-helmet";

import camp from "../../static/converted/oberlauf_camp-min.jpg";
import kran from "../../static/converted/oberlauf_kran-min.jpg";
import luft from "../../static/converted/oberlauf_luft-min.jpg";
import steg from "../../static/converted/oberlauf_steg-min.jpg";
import wasser from "../../static/converted/oberlauf_wasser-min.jpg";
import wehr from "../../static/converted/oberlauf_wehr-min.jpg";

import Imgmodal from "../imgmodal";

const Oberlauf = () => {
  const schemaOrgJSONLD = [
    {
      "@context": "http://schema.org",
      "@type": "Organization",
      sameAs: ["https://www.facebook.com/WallerWelt2.0/"],
      address: {
        "@type": "PostalAddress",
        addressLocality: "San Nazzaro, Italien",
        postalCode: "IT-29010",
        streetAddress: "Via Granelli 26"
      },
      email: "info(at)wallerwelt.com",
      alumni: [
        {
          "@type": "Person",
          name: "Markus Eule"
        },
        {
          "@type": "Person",
          name: "Mischa Eule"
        }
      ],
      member: [
        {
          "@type": "Organization"
        },
        {
          "@type": "Organization"
        }
      ],
      name: "Waller-Welt 2.0",
      contactPoint: [
        {
          "@type": "ContactPoint",
          telephone: "+39-345-997-3997",
          contactType: "customer service"
        }
      ]
    }
  ];
  return (
    <Container id="Oberlauf" className="main_content">
      <Helmet>
        {/* Schema.org tags */}
        <script type="application/ld+json">
          {JSON.stringify(schemaOrgJSONLD)}
        </script>
      </Helmet>

      <Grid verticalAlign="middle">
        <Grid.Column width={3} textAlign="right">
          <a href="https://www.facebook.com/WallerWelt2.0/" target="_blank">
            <Icon size="huge" name="facebook" />
          </a>
        </Grid.Column>
        <Grid.Column width={13}>
          <h1>Waller-Welt 2.0 am Po-Oberlauf</h1>
        </Grid.Column>
      </Grid>
      <br />
      <div className="responsive_map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1408.6434981419873!2d9.897892358375849!3d45.079972988734234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4780fb4bc15ff14f%3A0xb7fb87bcf0e4fe3a!2sWaller-Welt+2.0!5e0!3m2!1sde!2sde!4v1524816146791"
          width="600"
          height="450"
          frameBorder="0"
          allowFullScreen
        />
      </div>
      <Divider hidden />

      <Grid columns={2} stackable>
        <Grid.Column>
          <List>
            <List.Item>
              <Imgmodal img={kran} />
              <p>Unsere Hafenanlage in San Nazzaro</p>
            </List.Item>
            <List.Item>
              <Imgmodal img={luft} />
              <p>
                Der Staubereich oberhalb des Kraftwerks ist unser Revier. Der
                Mittellauf ist durch die Schleusenanlage erreichbar.
              </p>
            </List.Item>
            <List.Item>
              <Imgmodal img={wehr} />
              <p>Die Isola Serafine, links im Bild die alte Schleuse.</p>
            </List.Item>
          </List>
        </Grid.Column>
        <Grid.Column>
          <List>
            <List.Item>
              <Imgmodal img={steg} />
              <p>Ferienwohnungen und Zimmer direkt am Wasser.</p>
            </List.Item>
            <List.Item>
              <Imgmodal img={wasser} />
              <p>Unsere Hafenanlage vom Wasser aus.</p>
            </List.Item>
            <List.Item>
              <Imgmodal img={camp} />
              <p>
                Das Finstra sul Po, eine Trattoria versorgt Sie vom Frühstück
                bis zum Abendessen.
              </p>
            </List.Item>
          </List>
        </Grid.Column>
      </Grid>
    </Container>
  );
};

export default Oberlauf;



// WEBPACK FOOTER //
// ./src/components/Oberlauf/index.js